import classnames from "classnames";
import _ from "lodash";
import React, { useState, useEffect } from "react";
import Select from "react-select";
import { toast } from "react-toastify";
import moment from "moment-timezone";
import {
    Badge,
    Button,
    Card,
    CardHeader,
    Col,
    CustomInput,
    Form,
    FormGroup,
    Input,
    Label,
    Nav,
    NavItem,
    NavLink,
    Row,
    TabContent,
    TabPane,
    Modal,
    ModalBody,
    ModalHeader,
} from "reactstrap";
import { Field, FieldArray, Formik } from "formik";
import RequiredSelect from "./RequiredSelect";
import SweetAlert from "react-bootstrap-sweetalert/lib/dist/SweetAlert";
import QuestionList from "./questionList";
import { useFetch2 } from "components/utils/authenticatedHook";
import { useSelector } from "react-redux";
import encryptRequest from "../../helpers/encryptationHelper";
import { filteredTimezones } from "../../constants/general.constant";

function EducationQuestionDetails(props) {
    const { questionDetails, educationMaterial, educationMaterialLoader } = props;
    let [{ response: editEducationMaterialQuestion, error: educationMaterialQuestionError, isLoading: educationMaterialQuestionLoader }, doFetch2] = useFetch2();
    const [formData, setFormData] = useState({
        timezone: "America/New_York",
        name: "",
        condition: "",
        notifyStaff: [],
        notifySelf: [],
        materialType: "",
        messageCareprovider: "",
        patient: "",
        repeatPer: "",
        timeDuration: "",
        startDate: "",
        endDate: ""
    });
    const [initialValues, setInitialValues] = useState({
        is_edit_key: "",
        question: "",
        answers: [
            { answer: "", isCurrectAnswer: false },
            { answer: "", isCurrectAnswer: false },
        ],
    });
    const [questionModal, SetQuestionModal] = useState(false);
    const [questionData, SetQuestionData] = useState([]);
    const [activeTab, setActiveTab] = useState("1");
    const [questionError, setQuestionError] = useState("");
    const [isDelete, setIsDelete] = useState(false);
    const [isDeleteKey, setIsDeleteKey] = useState(undefined);
    const [isDeleteQuestion, setIsDeleteQuestion] = useState(false);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const [timeDurationError, setTimeDurationError] = useState("");
    const [startDateError, setStartDateError] = useState("");
    const [endDateError, setEndDateError] = useState("");
    const [deletedQuestions, setDeletedQuestions] = useState([]);
    const { userDetails } = useSelector(state => state.user);

    useEffect(() => {
        if (questionDetails) {
            const selectedTimezone = _.find(filteredTimezones, { value: questionDetails.timezone || "" });
            setFormData(prev => ({
                ...prev,
                name: questionDetails.name || "",
                condition: questionDetails.conditionGroup || "",
                notifyStaff: questionDetails.notifyStaff || [],
                notifySelf: questionDetails.notifySelf || [],
                materialType: questionDetails.educationMaterialType || "",
                messageCareprovider: questionDetails.messageCareprovider || "",
                patient: questionDetails.sharedUsers || "",
                repeatPer: questionDetails.repeatPer || "",
                timeDuration: questionDetails.timeDuration || "",
                endDate: questionDetails.endDate ? moment(questionDetails.endDate).format('YYYY-MM-DD') : "",
                startDate: questionDetails.startDate ? moment(questionDetails.startDate).format('YYYY-MM-DD') : "",
                timezone: selectedTimezone || ""
            }));
        }
        if (questionDetails && questionDetails.questions.length > 0) {
            SetQuestionData(questionDetails.questions);
        }
    }, [questionDetails]);

    function toggle(tab) {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    }

    function handleInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;
        const notifySelf = formData.notifySelf;
        const notifyStaff = formData.notifyStaff;

        if (target.type === "checkbox") {
            let index;
            if (target.checked) {
                // add the numerical value of the checkbox to options array
                if (name === "notifySelf") {
                    notifySelf.push(event.target.value);
                } else if (name === "notifyStaff") {
                    notifyStaff.push(event.target.value);
                }
            } else {
                // or remove the value from the unchecked checkbox from the array
                if (name === "notifySelf") {
                    index = notifySelf.indexOf(event.target.value);
                    notifySelf.splice(index, 1);
                } else if (name === "notifyStaff") {
                    index = notifyStaff.indexOf(event.target.value);
                    notifyStaff.splice(index, 1);
                }
            }
            setFormData((prev) => ({
                ...prev,
                notifySelf: notifySelf,
                notifyStaff: notifyStaff,
            }));
            return;
        }
        setFormData((prev) => ({
            ...prev, [name]: value,
        }));
    }

    const model = (key = "") => {
        SetQuestionModal(!questionModal);
        if (key !== "" && questionData[key]) {
            let answerValue = questionData[key];
            if (answerValue) {
                answerValue.is_edit_key = key;
                setInitialValues(answerValue);
            }
        } else {
            setInitialValues({
                is_edit_key: "",
                question: "",
                answers: [
                    { answer: "", isCurrectAnswer: false },
                    { answer: "", isCurrectAnswer: false },
                ],
            });
        }
    }
    const handleRepetedCondition = (selectedOption) => {
        setFormData((prev) => ({
            ...prev, repeatPer: selectedOption.value,
        }));
        if(selectedOption && selectedOption.value){
            setFormData((prev) => ({...prev, timeDuration: 'noEndDate'}))
        }
        setTimeDurationError("")
    }
    const handleMaterialType = (event) => {
        setFormData((prev) => ({
            ...prev, materialType: event,
        }));
    }
    const handleRadioChange = (e) => {
        const value = e.target?.value;
        setFormData((prev) => ({
            ...prev, timeDuration: value,
        }))
        setTimeDurationError("")
    }
    const handleInputDateChange = (e) => {
        const target = e.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;

        const formattedValue = moment(value).format("YYYY-MM-DD");

        setFormData((prev) => ({
            ...prev,
            [name]: formattedValue,
        }));
        if(formData.repeatPer === "once"){
        setFormData((prev) => ({
            ...prev,
            endDate: formattedValue,
        }));
        }
        // Clear existing errors
        setStartDateError('');
        setEndDateError('');

        // Defer validation until state update completes
        setTimeout(() => {
            validateDates(name === 'startDate' ? formattedValue : formData.startDate,
                (name === 'endDate' || formData.repeatPer === "once") ? formattedValue : formData.endDate);
        }, 0);
    };

    const validateDates = (startDate, endDate) => {
        if (formData.timeDuration !== 'byDate') return true;

        let isValid = true;

        // Validate empty dates
        if (!startDate) {
            setStartDateError('Please select a start date.');
            isValid = false;
        }

        if (!endDate) {
            setEndDateError('Please select an end date.');
            isValid = false;
        }

        if (startDate && endDate) {
            const start = moment(startDate, 'YYYY-MM-DD').startOf("day");;
            const end = moment(endDate, 'YYYY-MM-DD').endOf("day");
            if (end.isBefore(start)) {
                setEndDateError('End date must be greater than or equal to start date.');
                isValid = false;
            }
        }

        return isValid;
    };
    const handleChangePatient = (selectedOptions) => {
        const patientIds = selectedOptions?.map(option => option._id?.toString()) || [];
        setFormData((prev) => ({
            ...prev,
            patient: patientIds
        }));
    }
    const handleConditions = (selectedOptions) => {
        const conditionIds = selectedOptions?.map(option => option._id.toString()) || [];
        setFormData((prev) => ({
            ...prev, condition: conditionIds
        }));
    }
    const validate = (values) => {
        const errors = {};
        if (!values.question) {
            errors.question = "Question is Required";
        }
        var status = _.filter(values.answers, function (item) {
            return item.isCurrectAnswer === true;
        });
        if (status.length == 0) {
            errors.isCurrectAnswer = "At least one correct answer must be selected.";
        }
        // check duplicate answers added
        let duplicateOption = false;
        if (values && values.answers && values.answers.length) {
            // Filter out the duplicates
            _.map(values.answers, (item, index, self) => {
                const findDuplicate = _.filter(values.answers, (element, i) => i != index && element.answer.toLowerCase().replace(/\s+/g, '').trim() == item.answer.toLowerCase().replace(/\s+/g, '').trim())
                if (findDuplicate && findDuplicate.length > 0) {
                    duplicateOption = true;
                }
            });
            if (duplicateOption) {
                errors.isCurrectAnswer = "You cannot select the same option more than once.";
            }
        }
        // check duplicate question added
        let duplicateQuestion = false;
        if (questionData && questionData.length > 0) {
            // Filter out the duplicates
            _.map(questionData, (item, index) => {
                const findQuestion = values.question.toLowerCase().replace(/\s+/g, '').trim() == item.question.toLowerCase().replace(/\s+/g, '').trim()
                if (findQuestion && values.is_edit_key !== item.is_edit_key) {
                    duplicateQuestion = true;
                }
            });
            if (duplicateQuestion) {
                errors.isCurrectAnswer = "You are not allowed to add the same question more than once.";
            }
        }
        const data2 = Array.from(document.getElementsByClassName(`option-value`));
        data2.map((e, index) => {
            let checkValueLength = e.value.trim().length;
            if (checkValueLength === 0) {
                if (!errors.answers) errors.answers = [];
                errors.answers[index] = {
                    answer: "Option Value is Required",
                };
            }
        });
        return errors;
    };
    const handleSubmit = (values, resetForm) => {
        let arr = questionData;
        if (values.is_edit_key !== "") {
            const obj = arr[values.is_edit_key];
            const question = values.question;
            const answers = values.answers;
            if(question){
             delete obj.question;
            }
            if(answers){
             delete obj.answers;
            }
            arr[values.is_edit_key] = {
                question: question,
                answers: answers,
                ...obj
            };
        } else {
            arr.push({
                question: values.question,
                answers: values.answers,
            });
        }
        SetQuestionData(arr);
        SetQuestionModal(false);
        setQuestionError("");
    };
    const removeQuestion = (key) => {
        let questionDataUpdated = questionData;
        var selectedIndex = isDeleteKey;
        const deletedQuestionData = questionDataUpdated[selectedIndex] || null;
        if(deletedQuestionData){
            const questionsId = deletedQuestions || [];
            questionsId.push(deletedQuestionData._id)
            setDeletedQuestions(questionsId)
        }
        questionDataUpdated.splice(selectedIndex, 1);
        SetQuestionData(questionDataUpdated);
        setIsDelete(false);
    }
    const handleTimezone = (selectedOption) => {
        setFormData((prev) => ({
            ...prev,
            timezone: selectedOption,
        }));
    };
    const QuestionIsDelete = (key) => {
        setIsDelete(true);
        setIsDeleteKey(key);
    }
    const cancelDelete = () => {
        setIsDelete(false);
    }
    const removeEducationQuestion = () => {
        props.isQuestionnaireDelete(questionDetails);
        setIsDeleteQuestion(false);
    }
    const educationQuestionSubmit = (e) => {
        try {
            e.preventDefault();
            setIsFormSubmitted(true);
            if (isFormSubmitted && (!formData.timezone || _.isEmpty(formData.name) || _.isEmpty(formData.repeatPer) || (_.isEmpty(formData.messageCareprovider) && (formData.notifySelf.length > 0 || formData.notifyStaff.length > 0)))) {
                if (!formData.timeDuration) {
                    setTimeDurationError("You have to select at least one time duration")
                } else {
                    setTimeDurationError("")
                }
                return;
            }
            if (!formData.timeDuration) {
                setTimeDurationError("You have to select at least one time duration")
                return false;
            } else {
                setTimeDurationError("")
            }
            if (formData.timeDuration && (formData.timeDuration === 'byDate') && formData.startDate === "") {
                setStartDateError("You have to select start date");
                return false;
            }
            if (!_.isEmpty(startDateError) || !_.isEmpty(endDateError)) {
                return;
            }
            if (questionData.length === 0) {
                let message = "There should be more than one question.";
                setQuestionError(message);
                return false;
            }
            if ((formData.notifyStaff.length > 0 ||
                formData.notifySelf.length > 0) && formData.messageCareprovider?.trim().length === 0) {
                toast.error(
                    "A notification is checked in notify me/staff, please provide a message for the care prodiver/Staff"
                );
            }
            const timezone = formData.timezone && formData.timezone.value ? formData.timezone.value : 'America/New_York';
            const payload = {
                educationMaterialType: formData.materialType ? formData.materialType._id : "",
                messageCareprovider: formData?.messageCareprovider,
                notifySelf: formData?.notifySelf,
                notifyStaff: formData?.notifyStaff,
                name: formData?.name,
                timezone: timezone,
                editBy: userDetails && userDetails._id ? userDetails._id : '',
                questions: questionData,
                repeatPer: formData.repeatPer,
                timeDuration: formData.timeDuration,
                startDate: formData.startDate ? moment(formData.startDate).startOf('day').toDate() : null,
                endDate: formData.endDate ? moment(formData.endDate).endOf('day').toDate() : null,
                deletedData: deletedQuestions
            }
            if (formData.condition) {
                payload.conditionGroup = formData.condition
            }
            if (formData.patient) {
                payload.sharedUsers = formData.patient
            }
            doFetch2({
                url: "/edit-education-material-questions/" + encryptRequest(questionDetails._id),
                method: "PUT",
                disableWait: true,
                body: payload
            })
        } catch (error) {
            console.log('error', error)
        }
    }
    useEffect(() => {
        if (!educationMaterialQuestionLoader && isFormSubmitted) {
            setIsFormSubmitted(false)
            props.editQuestion(true);
        }
    }, [educationMaterialQuestionLoader, educationMaterialQuestionError])
    return (
        <div>
            {questionDetails && (
                <Form onSubmit={educationQuestionSubmit}>
                    <Card>
                        <CardHeader
                            tag="h4"
                            className="w-100 d-flex justify-content-between align-items-center"
                            style={{ background: "white" }}
                        >
                            <div>
                                <span>
                                    {questionDetails.name ? questionDetails.name : ''}
                                </span>
                            </div>
                            <div className="d-flex">
                                <>
                                    {" "}
                                    <button
                                        onClick={() => setIsDeleteQuestion(true)}
                                        type="button"
                                        className="btn btn-info ml-2 close-click-cls" >
                                        <i class="mdi mdi-close" style={{
                                            fontSize: 20
                                        }}></i>
                                        Delete
                                    </button>
                                    <button
                                        name="submit"
                                        className="btn btn-info ml-2 print-click-cls" disabled={educationMaterialQuestionLoader}>
                                        {educationMaterialQuestionLoader ? <i className="mdi mdi-loading mdi-spin mr-2" /> : <i className="mdi  mdi-content-save" style={{
                                            fontSize: 20,
                                            marginRight: 5
                                        }} />}
                                        Update
                                    </button>
                                </>
                            </div>
                        </CardHeader>
                    </Card>
                    <div className="row">
                        <div className="col-12 grid-margin">
                            <div className="card">
                                <div className="card-body project-tab pt-2">
                                    <Nav tabs className="justify-content-center">
                                        <NavItem>
                                            <NavLink
                                                className={classnames({
                                                    active: activeTab === "1",
                                                })}
                                                onClick={() => {
                                                    toggle("1");
                                                }}
                                            >
                                                GENERAL
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                className={classnames({
                                                    active: activeTab === "2",
                                                })}
                                                onClick={() => {
                                                    toggle("2");
                                                }}
                                            >
                                                NOTIFICATIONS
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                className={classnames({
                                                    active: activeTab === "3",
                                                })}
                                                onClick={() => {
                                                    toggle("3");
                                                }}
                                            >
                                                PATIENTS
                                            </NavLink>
                                        </NavItem>
                                    </Nav>
                                    <TabContent activeTab={activeTab}>
                                        <TabPane tabId="1">
                                            <Row>
                                                <Col sm="12" className="mt-5">
                                                    <FormGroup>
                                                        <Label for="exampleSelect">Select a Timezone</Label>
                                                        <RequiredSelect
                                                            SelectComponent={Select}
                                                            value={formData.timezone} // should be an object: { label, value }
                                                            onChange={handleTimezone}
                                                            options={filteredTimezones}
                                                            name="timezone"
                                                        />
                                                        <span>
                                                            {(formData && !formData.timezone && isFormSubmitted) ? (
                                                                <div className="input-feedback">
                                                                    Timezone is required
                                                                </div>
                                                            ) : null}
                                                        </span>
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <Label for="exampleSelect">Select a Education Material Type</Label>
                                                        <RequiredSelect
                                                            SelectComponent={Select}
                                                            value={formData.materialType}
                                                            onChange={handleMaterialType}
                                                            options={
                                                                educationMaterial && educationMaterial.educationMaterialType
                                                                    ? educationMaterial.educationMaterialType
                                                                    : []
                                                            }
                                                            isMulti={false}
                                                            getOptionLabel={(option) => option["materialType"]}
                                                            getOptionValue={(option) => option}
                                                            name="materialType"
                                                        />
                                                        <span>
                                                            {(formData && !formData.materialType && isFormSubmitted) ? (
                                                                <div className="input-feedback">
                                                                    Educational material type is required
                                                                </div>
                                                            ) : null}
                                                        </span>
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <Label for="exampleEmail">Questionnaire Title</Label>
                                                        <Input
                                                            type="text"
                                                            name="name"
                                                            id="exampleEmail"
                                                            defaultValue={formData.name}
                                                            // required={true}
                                                            onChange={handleInputChange}
                                                            placeholder="Questionnaire Title"
                                                            className="question-input-field input-date-filter"
                                                        />
                                                        <span>
                                                            {(formData && isFormSubmitted && _.isEmpty(formData.name)) ? (
                                                                <div className="input-feedback">
                                                                    Questionnaire title is required
                                                                </div>
                                                            ) : null}
                                                        </span>
                                                    </FormGroup>
                                                    <Row form>
                                                        <Col md={12}>
                                                            <FormGroup>
                                                                <Label for="exampleSelect">Select Frequency</Label>
                                                                <RequiredSelect
                                                                    SelectComponent={Select}
                                                                    value={[
                                                                        { value: "once", label: "Once" },
                                                                        { value: "day", label: "Daily" },
                                                                        {
                                                                            value: "everyOtherDay",
                                                                            label: "Every Other Day",
                                                                        },
                                                                        { value: "week", label: "Week" },
                                                                        { value: "month", label: "Month" },
                                                                    ].filter(
                                                                        ({ value }) => value === formData.repeatPer
                                                                    )}
                                                                    onChange={handleRepetedCondition}
                                                                    options={[
                                                                        { value: "once", label: "Once" },
                                                                        { value: "day", label: "Daily" },
                                                                        {
                                                                            value: "everyOtherDay",
                                                                            label: "Every Other Day",
                                                                        },
                                                                        { value: "week", label: "Week" },
                                                                        { value: "month", label: "Month" },
                                                                    ]}
                                                                />
                                                                <span>
                                                                    {(formData && isFormSubmitted && !formData.repeatPer && _.isEmpty(formData.repeatPer)) ? (
                                                                        <div className="input-feedback">
                                                                            Frequency is required
                                                                        </div>
                                                                    ) : null}
                                                                </span>
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                    <Row form>
                                                        {formData.repeatPer !== "once" &&<Col md={4} className="p-2">
                                                            <FormGroup>
                                                                <Label for="exampleSelect">Select Time Duration</Label>
                                                                <div className="radio-group">
                                                                    <Label>
                                                                        <Input
                                                                            name="timeDuration"
                                                                            type="radio"
                                                                            value="byDate"
                                                                            onChange={handleRadioChange}
                                                                            className="radio-questionnarie-input"
                                                                            checked={formData.timeDuration === "byDate"}
                                                                        />
                                                                        <span className="radio-questionnarie-text">By Date</span>
                                                                    </Label>
                                                                    <Label>
                                                                        <Input
                                                                            name="timeDuration"
                                                                            type="radio"
                                                                            value="noEndDate"
                                                                            onChange={handleRadioChange}
                                                                            className="radio-questionnarie-input"
                                                                            checked={formData.timeDuration === "noEndDate"}
                                                                        />
                                                                        <span className="radio-questionnarie-text">No End Date</span>
                                                                    </Label>
                                                                </div>
                                                                <span>
                                                                    {timeDurationError !== "" ? (
                                                                        <div className="input-feedback">
                                                                            {timeDurationError}
                                                                        </div>
                                                                    ) : null}
                                                                </span>
                                                            </FormGroup>
                                                        </Col>}
                                                        {(formData.timeDuration === 'byDate') && (
                                                            <Col md={4} className="p-2">
                                                                <FormGroup className="remove-bottom-margin form-group-patient">
                                                                    <Label for="exampleStartDate">Start Date:</Label>
                                                                    <Input
                                                                        className="input-date-filter remove-bottom-margin"
                                                                        type="date"
                                                                        name="startDate"
                                                                        min={moment().format("YYYY-MM-DD")}
                                                                        onChange={handleInputDateChange}
                                                                        value={formData.startDate}
                                                                        style={{ "min-height": "56px" }}
                                                                    />
                                                                    <span>
                                                                        {startDateError !== "" ? (
                                                                            <div className="input-feedback">
                                                                                {startDateError}
                                                                            </div>
                                                                        ) : null}
                                                                    </span>
                                                                </FormGroup>
                                                            </Col>
                                                        )}
                                                        {formData.repeatPer !== "once" && formData.timeDuration === 'byDate' && (
                                                            <Col md={4} className="p-2">
                                                                <FormGroup className="remove-bottom-margin form-group-patient">
                                                                    <Label for="exampleEndDate">End Date:</Label>
                                                                    <Input
                                                                        className="input-date-filter remove-bottom-margin pd-4"
                                                                        type="date"
                                                                        name="endDate"
                                                                        min={moment().format("YYYY-MM-DD")}
                                                                        onChange={handleInputDateChange}
                                                                        value={formData.endDate}
                                                                        style={{ "min-height": "56px" }}
                                                                    />
                                                                    <span>
                                                                        {endDateError !== "" ? (
                                                                            <div className="input-feedback">
                                                                                {endDateError}
                                                                            </div>
                                                                        ) : null}
                                                                    </span>
                                                                </FormGroup>
                                                            </Col>
                                                        )}
                                                    </Row>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <FormGroup>
                                                        <div className="col-12" style={{ padding: 0 }}>
                                                            <Label
                                                                for="exampleEmail"
                                                                style={{ lineHeight: 3 }}
                                                            >
                                                                Questions
                                                            </Label>
                                                            <Button
                                                                className="float-right text-white"
                                                                color="danger"
                                                                size="sm"
                                                                style={{
                                                                    alignItems: "flex-end",
                                                                    borderRadius: 7,
                                                                }}
                                                                onClick={model}
                                                            >
                                                                Add Question
                                                            </Button>
                                                        </div>
                                                        <QuestionList
                                                            actions={[
                                                                { click: model, label: "Edit" },
                                                                { click: QuestionIsDelete, label: "Delete" },
                                                            ]}
                                                            question_list={questionDetails.questions ? questionDetails.questions : []}
                                                        />
                                                        <SweetAlert
                                                            title="Are you sure?"
                                                            warning
                                                            showCancel={true}
                                                            show={isDelete}
                                                            confirmBtnText="Yes, delete it!"
                                                            confirmBtnBsStyle="danger"
                                                            cancelBtnBsStyle="default"
                                                            onConfirm={removeQuestion}
                                                            onCancel={cancelDelete}
                                                        >
                                                            Your Question is Not Show After Delete
                                                        </SweetAlert>
                                                        <span style={{ padding: 7, fontSize: 18 }}>
                                                            {questionError !== "" ? (
                                                                <div className="input-feedback">
                                                                    {questionError}
                                                                </div>
                                                            ) : null}
                                                        </span>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </TabPane>
                                        <TabPane tabId="2">
                                            <Row>
                                                <Col sm="12" className="grid-margin mt-5">
                                                    <FormGroup>
                                                        <Label for="exampleText">
                                                            Notification Message (Careprovider)
                                                        </Label>
                                                        <Input
                                                            type="textarea"
                                                            name="messageCareprovider"
                                                            value={formData.messageCareprovider}
                                                            onChange={handleInputChange}
                                                            rows={10}
                                                        />
                                                        <span>
                                                            {(formData && isFormSubmitted && !formData.messageCareprovider && _.isEmpty(formData.messageCareprovider)) ? (
                                                                <div className="input-feedback">
                                                                    Notification message is required
                                                                </div>
                                                            ) : null}
                                                        </span>
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <Label for="exampleCheckbox">Notify Me</Label>
                                                        <div>
                                                            <CustomInput
                                                                type="checkbox"
                                                                id="exampleCustomInline"
                                                                name="notifySelf"
                                                                checked={_.includes(
                                                                    formData.notifySelf,
                                                                    "inbox"
                                                                )}
                                                                onChange={handleInputChange}
                                                                value="inbox"
                                                                label="Inbox"
                                                                inline
                                                            />
                                                            <CustomInput
                                                                type="checkbox"
                                                                id="exampleCustomInline2"
                                                                name="notifySelf"
                                                                checked={_.includes(
                                                                    formData.notifySelf,
                                                                    "sms"
                                                                )}
                                                                onChange={handleInputChange}
                                                                label="SMS"
                                                                value="sms"
                                                                inline
                                                            />
                                                            <CustomInput
                                                                type="checkbox"
                                                                id="exampleCustomInline3"
                                                                name="notifySelf"
                                                                checked={_.includes(
                                                                    formData.notifySelf,
                                                                    "voice"
                                                                )}
                                                                onChange={handleInputChange}
                                                                label="VOICE"
                                                                value="voice"
                                                                inline
                                                            />
                                                            <CustomInput
                                                                type="checkbox"
                                                                id="exampleCustomInline4"
                                                                name="notifySelf"
                                                                checked={_.includes(
                                                                    formData.notifySelf,
                                                                    "email"
                                                                )}
                                                                onChange={handleInputChange}
                                                                label="EMAIL"
                                                                value="email"
                                                                inline
                                                            />
                                                        </div>
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <Label for="exampleCheckbox">Notify Staff</Label>
                                                        <div>
                                                            <CustomInput
                                                                type="checkbox"
                                                                id="exampleCustomInline10"
                                                                name="notifyStaff"
                                                                onChange={handleInputChange}
                                                                checked={_.includes(
                                                                    formData.notifyStaff,
                                                                    "inbox"
                                                                )}
                                                                value="inbox"
                                                                label="Inbox"
                                                                inline
                                                            />
                                                            <CustomInput
                                                                type="checkbox"
                                                                id="exampleCustomInline11"
                                                                name="notifyStaff"
                                                                onChange={handleInputChange}
                                                                checked={_.includes(
                                                                    formData.notifyStaff,
                                                                    "sms"
                                                                )}
                                                                label="SMS"
                                                                value="sms"
                                                                inline
                                                            />
                                                            <CustomInput
                                                                type="checkbox"
                                                                id="exampleCustomInline12"
                                                                name="notifyStaff"
                                                                onChange={handleInputChange}
                                                                checked={_.includes(
                                                                    formData.notifyStaff,
                                                                    "voice"
                                                                )}
                                                                label="VOICE"
                                                                value="voice"
                                                                inline
                                                            />
                                                            <CustomInput
                                                                type="checkbox"
                                                                id="exampleCustomInline13"
                                                                name="notifyStaff"
                                                                onChange={handleInputChange}
                                                                checked={_.includes(
                                                                    formData.notifyStaff,
                                                                    "email"
                                                                )}
                                                                label="EMAIL"
                                                                value="email"
                                                                inline
                                                            />
                                                        </div>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </TabPane>
                                        <TabPane tabId="3">
                                            <Row>
                                                <Col sm="12" className="grid-margin mt-5">
                                                    <>
                                                        <FormGroup>
                                                            <Label for="exampleSelect">
                                                                Select a Condition to Monitor
                                                            </Label>
                                                            <Select
                                                                value={
                                                                    educationMaterial?.condition && formData?.condition
                                                                        ? educationMaterial.condition.filter((opt) =>
                                                                            formData.condition.includes(opt._id.toString())
                                                                        )
                                                                        : []
                                                                }
                                                                onChange={handleConditions}
                                                                options={educationMaterial?.condition || []}
                                                                isMulti={true}
                                                                getOptionLabel={(option) =>
                                                                    `${option.condition}`
                                                                }
                                                                getOptionValue={(option) => option._id.toString()}
                                                                isLoading={educationMaterialLoader}
                                                                isDisabled={educationMaterialLoader}
                                                                noOptionsMessage={() => "No Conditions Found"}
                                                            />
                                                        </FormGroup>
                                                        <FormGroup>
                                                            <Label for="exampleSelect">
                                                                Select a Patient to Monitor
                                                            </Label>
                                                            <Select
                                                                value={
                                                                    educationMaterial?.patients && formData?.patient
                                                                        ? educationMaterial.patients.filter((opt) =>
                                                                            formData.patient.includes(opt._id?.toString())
                                                                        )
                                                                        : []
                                                                }
                                                                onChange={handleChangePatient}
                                                                options={educationMaterial?.patients || []}
                                                                isMulti={true}
                                                                getOptionLabel={(option) => `${option.fname} ${option.lname}`}
                                                                getOptionValue={(option) => option._id.toString()}
                                                                isLoading={!!educationMaterialLoader}
                                                                isDisabled={!!educationMaterialLoader}
                                                                noOptionsMessage={() => 'No Patients Found'}
                                                            />
                                                        </FormGroup>
                                                    </>
                                                </Col>
                                            </Row>
                                        </TabPane>
                                    </TabContent>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row" />
                </Form>)}
            {/* Question add modal */}
            <Modal isOpen={questionModal} toggle={model}>
                <ModalHeader toggle={model}>Add Question</ModalHeader>
                <ModalBody>
                    <Formik
                        enableReinitialize={true}
                        initialValues={initialValues}
                        validate={(values) => validate(values)}
                        onSubmit={(values, { resetForm }) =>
                            handleSubmit(values, resetForm)
                        }
                    >
                        {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            isSubmitting,
                            /* and other goodies */
                        }) => {
                            return (
                                <Form onSubmit={handleSubmit}>
                                    <FormGroup>
                                        <Label
                                            style={{
                                                fontSize: 17,
                                            }}
                                        >
                                            Question
                                        </Label>
                                        <Input
                                            type="text"
                                            name="question"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.question}
                                            placeholder="Enter question"
                                            style={{ borderRadius: 7 }}
                                        />
                                        {errors.question && touched.question && (
                                            <div className="input-feedback">
                                                {errors.question}
                                            </div>
                                        )}
                                    </FormGroup>
                                    <Row>
                                        <Col lg={12} md={12} xs={12}>
                                            <FieldArray
                                                name="answers"
                                                render={(arrayHelpers) => (
                                                    <div>
                                                        {values.answers && values.answers.length > 0
                                                            ? values.answers.map((answers, index) => {
                                                                const option_valueErrors =
                                                                    (errors.answers?.length &&
                                                                        errors.answers[index]?.answer) ||
                                                                    "";
                                                                const option_valueTouched =
                                                                    (touched.answers?.length &&
                                                                        touched.answers[index]?.answer) ||
                                                                    "";
                                                                return (
                                                                    <>
                                                                        <div key={"answer-" + index}>
                                                                            <Row>
                                                                                <Col lg={12}>
                                                                                    <FormGroup>
                                                                                        <Label
                                                                                            style={{
                                                                                                fontSize: 17,
                                                                                            }}
                                                                                        >
                                                                                            Option
                                                                                        </Label>
                                                                                        <div>
                                                                                            <Row>
                                                                                                <Col lg={8} xs={8}>
                                                                                                    <Field
                                                                                                        name={`answers.${index}.answer`}
                                                                                                        placeholder={
                                                                                                            "Enter option"
                                                                                                        }
                                                                                                        type="text"
                                                                                                        className={
                                                                                                            "form-control form-field option-value " +
                                                                                                            (option_valueTouched &&
                                                                                                                option_valueErrors
                                                                                                                ? " form-field-error"
                                                                                                                : option_valueTouched &&
                                                                                                                    !option_valueErrors
                                                                                                                    ? " form-field-success"
                                                                                                                    : "")
                                                                                                        }
                                                                                                        // value={answers.answer}
                                                                                                        onChange={
                                                                                                            handleChange
                                                                                                        }
                                                                                                        handleBlur={
                                                                                                            handleBlur
                                                                                                        }
                                                                                                    />
                                                                                                    <span>
                                                                                                        {option_valueTouched &&
                                                                                                            option_valueErrors ? (
                                                                                                            <div className="input-feedback">
                                                                                                                {
                                                                                                                    option_valueErrors
                                                                                                                }
                                                                                                            </div>
                                                                                                        ) : null}
                                                                                                    </span>
                                                                                                </Col>
                                                                                                <Col
                                                                                                    lg={4}
                                                                                                    xs={4}
                                                                                                    className="d-flex"
                                                                                                >
                                                                                                    <CustomInput
                                                                                                        className="custom-correct-checkbox"
                                                                                                        type="checkbox"
                                                                                                        onChange={
                                                                                                            handleChange
                                                                                                        }
                                                                                                        onBlur={handleBlur}
                                                                                                        // value={
                                                                                                        //     answers.isCurrectAnswer
                                                                                                        // }
                                                                                                        checked={
                                                                                                            answers.isCurrectAnswer
                                                                                                        }
                                                                                                        id={`answers.${index}.isCurrectAnswer`}
                                                                                                        name={`answers.${index}.isCurrectAnswer`}
                                                                                                        label="Is correct"
                                                                                                        inline
                                                                                                    />
                                                                                                    {index >= 2 && (
                                                                                                        <Badge
                                                                                                            style={{
                                                                                                                cursor: "pointer",
                                                                                                                fontSize: 13,
                                                                                                                borderRadius: 7,
                                                                                                                width: 32,
                                                                                                                height: 32,
                                                                                                            }}
                                                                                                            className="m-1 p-2"
                                                                                                            color="danger"
                                                                                                            pill
                                                                                                            onClick={() =>
                                                                                                                arrayHelpers.remove(
                                                                                                                    index
                                                                                                                )
                                                                                                            }
                                                                                                        >
                                                                                                            X
                                                                                                        </Badge>
                                                                                                    )}
                                                                                                </Col>
                                                                                            </Row>
                                                                                        </div>
                                                                                    </FormGroup>
                                                                                </Col>
                                                                            </Row>
                                                                        </div>
                                                                    </>
                                                                );
                                                            })
                                                            : ""}
                                                        <Button
                                                            size="sm"
                                                            style={{ borderRadius: 7 }}
                                                            className={"secondary-add-button"}
                                                            onClick={() =>
                                                                arrayHelpers.push({
                                                                    answer: "",
                                                                    isCurrectAnswer: false,
                                                                })
                                                            }
                                                        >
                                                            Add
                                                        </Button>
                                                        <div className="input-feedback">
                                                            {errors.isCurrectAnswer ? (
                                                                <div> Note : {errors.isCurrectAnswer}</div>
                                                            ) : null}
                                                            {errors.duplicatesOption ? (
                                                                <div> Note : {errors.duplicatesOption}</div>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                )}
                                            />
                                        </Col>
                                    </Row>
                                    <br></br>
                                    <button
                                        type="submit"
                                        className="btn btn-block btn-info"
                                        value="Submit"
                                        disabled={isSubmitting}
                                    >
                                        Save
                                    </button>
                                </Form>
                            );
                        }}
                    </Formik>
                </ModalBody>
            </Modal>

            <SweetAlert
                title="Are you sure?"
                warning
                showCancel={true}
                show={isDeleteQuestion}
                confirmBtnText="Yes, delete it!"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="default"
                onConfirm={removeEducationQuestion}
                onCancel={() => setIsDeleteQuestion(false)}
            >
                Are you sure you want to delete this question? Once deleted, it will no longer be displayed.
            </SweetAlert>
        </div>
    )
}

export default EducationQuestionDetails;